import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Register from './Register.js';
import Category from './Category.js';
import Vote from './Vote.js';
import Results from './Results.js';
import Winner from './Winner.js';
import './App.css';

function App() {
    const location = useLocation();

    return (
        <TransitionGroup>
            <CSSTransition key={location.key} classNames='fade' timeout={300}>
                <Routes location={location}>
                    <Route path='/' element={<Register />} />
                    <Route path='/category' element={<Category />} />
                    <Route path='/vote/:category' element={<Vote />} />
                    <Route path='/results' element={<Results />} />
                    <Route path='/winner' element={<Winner />} />
                </Routes>
            </CSSTransition>
        </TransitionGroup>
    )
}

export default App;